import {createContext} from "react";

export const TurmsContext = createContext({
    trumsClient: undefined
})
